var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossSwapStatusBarSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.741,
    y: 1,
    width: 295.387,
    height: 12,
    rx: 6,
    fill: "#4DBC9B",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 288.741,
    cy: 7,
    r: 7,
    fill: "#4DBC9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.241 6.5l2 2 3.5-3.5",
    stroke: "#E9F4F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjk3IiBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgMjk3IDE0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSIwLjc0MTIxMSIgeT0iMSIgd2lkdGg9IjI5NS4zODciIGhlaWdodD0iMTIiIHJ4PSI2IiBmaWxsPSIjNERCQzlCIiBmaWxsLW9wYWNpdHk9IjAuMSIvPgo8Y2lyY2xlIGN4PSIyODguNzQxIiBjeT0iNyIgcj0iNyIgZmlsbD0iIzREQkM5QiIvPgo8cGF0aCBkPSJNMjg2LjI0MSA2LjVMMjg4LjI0MSA4LjVMMjkxLjc0MSA1IiBzdHJva2U9IiNFOUY0RjIiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgCrossSwapStatusBarSuccess as ReactComponent };